@if (message(); as errorMessage) {
  <div class="error-status-bar-wrapper visible">
    <nz-alert
      class="error-status-bar"
      nzType="error"
      nzShowIcon
      [nzIcon]="errorStatusIcon"
      [nzMessage]="messageTemplate"
    ></nz-alert>

    <ng-template #messageTemplate>
      <div class="error-content">
        <div class="error-message">{{ errorMessage }}</div>
        <div class="tenant-badge" *ngIf="tenantDisplayName() || version">
          <span class="tenant-name">{{ tenantDisplayName() }}</span>
          <span class="tenant-version" *ngIf="version">/ {{ version }}</span>
        </div>
      </div>
    </ng-template>

    <ng-template #errorStatusIcon>
      <dpqa-icon iconName="info" iconSize="2" />
    </ng-template>
  </div>
}
